import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	gap: 1rem;
	padding-bottom: 5px;
	background-color: ${color.interface.white};
`;

export const noBanners = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 1rem;

	> p {
		font-size: 1.4rem;
	}
`;
